import { createStyles, makeStyles, Theme } from '@material-ui/core';


const useStyles = makeStyles(({ colors, breakpoints }: Theme) => createStyles({
  container: {
    paddingTop: 30,
    paddingLeft: 8,
    paddingRight: 8,
  },
  titleContainer: {
    marginBottom: 20,
    // marginTop: 30,
    width: '100%',
    [breakpoints.down('xs')]: {
      width: '100%',
      marginBottom: 24,
    },
  },
  titleContainerWithActionPanel: {
    width: 'auto',
  },
  title: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: colors.navigation,
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 500,
    fontStyle: 'normal',
    fontSize: '24px',
    marginTop: 0,
    marginBottom: 0,
  },
  breadcrumbs: {
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: 20,
    marginBottom: 20,
  },
  topPanel: {
    justifyContent: 'space-between',
  },
}), { name: 'ViewFrame' });

export default useStyles;
